var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgSignIn = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H13.5C13.2239 21 13 20.7761 13 20.5V19.5C13 19.2239 13.2239 19 13.5 19H19V5H13.5C13.2239 5 13 4.77614 13 4.5V3.5C13 3.22386 13.2239 3 13.5 3ZM17 11.81V12.19C16.9998 12.3888 16.9207 12.5795 16.78 12.72L11.64 17.85C11.5461 17.9447 11.4183 17.9979 11.285 17.9979C11.1517 17.9979 11.0239 17.9447 10.93 17.85L10.22 17.15C10.1253 17.0561 10.0721 16.9283 10.0721 16.795C10.0721 16.6617 10.1253 16.5339 10.22 16.44L13.67 13H3.5C3.22386 13 3 12.7761 3 12.5V11.5C3 11.2239 3.22386 11 3.5 11H13.67L10.22 7.56C10.1259 7.46784 10.0729 7.34169 10.0729 7.21C10.0729 7.07831 10.1259 6.95216 10.22 6.86L10.93 6.15C11.0239 6.05534 11.1517 6.0021 11.285 6.0021C11.4183 6.0021 11.5461 6.05534 11.64 6.15L16.78 11.28C16.9189 11.4217 16.9977 11.6116 17 11.81Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSignIn, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sign_in.65e23ba4.svg";
export { ForwardRef as ReactComponent };